module.exports = __webpack_public_path__ + "static/media/Lato-Thin.454421e7.ttf";